import axios from 'axios';
import DataModel from '../models/DataModel.js';
import serviceUtil from './serviceUtil';

let helpers = {
  generateKmzFile(type, id){
    let request = process.env.REACT_APP_API + '/kmz/' + type + '/' + id + '/generate?current_company=' + localStorage.current_company_id;

    return axios({
      method: 'post',
      url: request,
      headers: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Pragma': 'no-cache',
        'Expires': '0',
        'Content-Type': 'application/json',
        'Accept': '*/*',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
    .then(response => {
      return response.data;
    })
    .catch(error => {
      return serviceUtil.resultForError(error);
    });
  },

  downloadKmzFile(type, id, attachment_id){
    let request = process.env.REACT_APP_API + '/kmz/' + type + '/' + id +
      '/download?current_company=' + localStorage.current_company_id + '&attachment_id=' + attachment_id;

    return axios({
      method: 'get',
      url: request,
      headers: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Pragma': 'no-cache',
        'Expires': '0',
        'Content-Type': 'application/json',
        'Accept': '*/*',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
    .then(response => {
      return response.data;
    })
    .catch(error => {
      return serviceUtil.resultForError(error);
    });
  },
};

export default helpers;




// WEBPACK FOOTER //
// ./src/services/kmzService.js